import { SET_CUSTOMER_DATA } from './constants';

const initialState = {
  list: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CUSTOMER_DATA:
      return {
        ...state,
        list: action.payload
      };
    default:
      return state;
  }
};

export default reducer;